import { Component, OnInit, OnDestroy } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {CounterService} from '../_services/counter.service';
import {TimeService} from '../_services/time.service';
import {IncomingdrawsService} from '../_services/incomingdraws.service';
import {CurrencyService} from '../_services/currency.service';
import {JackpotConfigService} from '../_services/jackpotConfig.service';
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, OnDestroy {
    desktop: any;
    itemsArr: Observable<any>;
    itemsSize: number;
    nav: true;
    languageChange: Subscription;
    showLang: any;
    priceName: any;
    xx: any;
    changedCurrency: Subscription;
    currency: any;
    done: any;
  constructor(private lotteriesService: LotteriesService, public subscriptionsService: SubscriptionsService,
              public counterService: CounterService, public timeService: TimeService,
              public incomingDrawsService: IncomingdrawsService,
              public currencyService: CurrencyService,
              public jackpotConfig: JackpotConfigService) {
      this.done = false;
      this.getLang();
      this.checkForIncomingDraws();

      this.languageChange = this.subscriptionsService.getLanguage().subscribe( lang => {
          this.showLang = lang;
          if ( this.showLang === 'en') {
              this.priceName = 'jackpotAsStringRounded';
          } else {
              this.priceName = 'jackpotAsStringRoundedDE';
          }
      });

      this.currency = this.currencyService.currency;
      this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
          if (currency) {
              this.currency = currency;
          }
      });

      setTimeout(() => {
          this.done = true;
      }, 1500)
  }

  ngOnDestroy() {
      if (this.languageChange) {
          this.languageChange.unsubscribe();
      }
      if (this.changedCurrency) {
          this.changedCurrency.unsubscribe();
      }
  }

  ngOnInit() {
  }

   getRestLotteries(result) {
      this.itemsArr = result;
       this.itemsSize = result.length;
   }

    checkForIncomingDraws() {
        if (this.incomingDrawsService.incomingDraws) {
            this.getRestLotteries(this.incomingDrawsService.incomingDraws);
        } else {
            setTimeout(() => {
                this.checkForIncomingDraws();
            }, 400);
        }
    }

  valueOfIndex(i, v) {
      return this.itemsArr[i][v];
  }

    counter(i: number) {
        return new Array(i);
    }

  getLang() {
      if ( localStorage.getItem('pageLanguage') === 'de'
        || localStorage.getItem('pageLanguage') === 'en'
        || localStorage.getItem('pageLanguage') === 'id'
        || localStorage.getItem('pageLanguage') === 'vi') {
          this.showLang = localStorage.getItem('pageLanguage');
      } else {
          setTimeout(() => {
              this.getLang();
          }, 200);
      }
  }

}
